angular.module('shared').constant 'FeatureFlag',
  EventCancellations: 'cancelled-events'

angular.module('shared').factory 'FeatureFlagsService', ->

  enabledFeatures = window.cwxEnabledFeatures || []

  {
    enabledFeatures: enabledFeatures
    isEnabled: (featureCode) -> enabledFeatures.indexOf(featureCode) isnt -1
  }
